import { Button, ButtonGroup, Modal, Table } from "flowbite-react";
import { useEffect } from "react";
import { useReducerAsState } from "../hooks/useReducerAsState";
import TableResults from "./TableResults";
import { AnalyticsGroupType } from "../routes/ads-sections-details";
import useAdAnalytics from "../hooks/useAdAnalytics";
import { AdAnalyticsType } from "../types/ad.analytics";
import { nFormatter } from "../utils/formatters";

enum FilterType {
  yesterday = "yesterday",
  today = "today",
  this_week = "this_week",
  this_month = "this_month",
}

interface Props {
  data: AnalyticsGroupType;
  groupId: number;
  onClose: () => void;
  show?: boolean;
}

interface State {
  show: boolean;
  filter: FilterType;
  analyticsGroup: AdAnalyticsType | null;
}

const _FILTERS = [
  {
    value: FilterType.yesterday,
    label: "Ayer",
  },
  {
    value: FilterType.today,
    label: "Hoy",
  },
  {
    value: FilterType.this_week,
    label: "Esta semana",
  },
  {
    value: FilterType.this_month,
    label: "Este mes",
  },
];

const ModalAnalytics = ({
  data,
  groupId = 0,
  show = false,
  onClose,
}: Props) => {
  const { loadingAnalyticsGroup, getAnalyticsGroup } = useAdAnalytics();

  const [state, setState] = useReducerAsState<State>({
    show: false,
    filter: FilterType.yesterday,
    analyticsGroup: null,
  });

  const _setShow = (show: boolean) => setState({ show });
  const _onSelectedDateFilter = async (filter: FilterType) => {
    setState({ filter });
    await _initialize(filter);
  };

  const _initialize = async (filter?: FilterType) => {
    const response = await getAnalyticsGroup(
      groupId,
      data.slug,
      filter ?? state.filter
    );
    setState({ analyticsGroup: response, filter: filter ?? state.filter });
  };

  useEffect(() => {
    _setShow(show);
    // eslint-disable-next-line
  }, [show]);

  useEffect(() => {
    _initialize();
    // eslint-disable-next-line
  }, []);

  return (
    <Modal show={state.show} onClose={onClose}>
      <Modal.Header>
        <h1>Analíticas</h1>
      </Modal.Header>
      <Modal.Body>
        <ButtonGroup>
          {_FILTERS.map((button) => (
            <Button
              color={state.filter === button.value ? "dark" : "gray"}
              onClick={() => _onSelectedDateFilter(button.value)}
            >
              {button.label}
            </Button>
          ))}
        </ButtonGroup>
        <br />
        <br />
        <p>
          Vea aquí las estadísticas de las visitas a la sección seleccionada
        </p>
        <br />
        <TableResults
          loading={loadingAnalyticsGroup}
          error=""
          itemsCount={(state.analyticsGroup?.analytics ?? []).length}
        >
          <Table>
            <Table.Head>
              <Table.HeadCell></Table.HeadCell>
              <Table.HeadCell>Visitas</Table.HeadCell>
              <Table.HeadCell>Clics</Table.HeadCell>
            </Table.Head>
            <Table.Body className="divide-y">
              {state.analyticsGroup &&
                (state.analyticsGroup.analytics ?? []).map((item, index) => (
                  <Table.Row
                    key={`table_${index}`}
                    className="bg-white dark:border-gray-700 dark:bg-gray-800"
                  >
                    <Table.Cell className="whitespace-nowrap font-medium text-gray-900 dark:text-white">
                      {item.title}
                    </Table.Cell>
                    <Table.Cell>{nFormatter(item.views, 1)}</Table.Cell>
                    <Table.Cell>{nFormatter(item.clicks, 1)}</Table.Cell>
                  </Table.Row>
                ))}
            </Table.Body>
          </Table>
        </TableResults>
        <br />
        <p>Listado por país</p>
        <br />
        <TableResults
          loading={loadingAnalyticsGroup}
          error=""
          itemsCount={(state.analyticsGroup?.countries ?? []).length}
        >
          <Table>
            <Table.Head>
              <Table.HeadCell></Table.HeadCell>
            </Table.Head>
            <Table.Body className="divide-y">
              {state.analyticsGroup &&
                (state.analyticsGroup.countries ?? []).map((item, index) => (
                  <Table.Row
                    key={`table_${index}`}
                    className="bg-white dark:border-gray-700 dark:bg-gray-800"
                  >
                    <Table.Cell className="whitespace-nowrap font-medium text-gray-900 dark:text-white">
                      {item.title}
                    </Table.Cell>
                  </Table.Row>
                ))}
            </Table.Body>
          </Table>
        </TableResults>
      </Modal.Body>
    </Modal>
  );
};

export default ModalAnalytics;
